import {
  SprayOrSprayZoneChartConfigDto,
  BatterReportChartConfigDto,
  SprayOrSprayZoneChartView,
  BatterSessionReportChartConfigDto,
  ChartType,
} from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import GenericRadioConfig from 'components/Configs/GenericRadioConfig';
import { Typography } from '@trackman/web-shared-components';
import { useChartTitle } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';

type ReportConfig = BatterReportChartConfigDto | BatterSessionReportChartConfigDto;

type Props<TReportConfig extends ReportConfig> = ChartConfigProps<SprayOrSprayZoneChartConfigDto, TReportConfig> & {
  chartId: ChartType;
  chartKey: keyof TReportConfig;
};

const PlayerSprayOrSprayZoneChartSidebar = <T extends ReportConfig>({
  extraChartData,
  setTempLayout,
  tempLayout,
  chartId,
  chartKey,
}: Props<T>) => {
  const { getChartTitle } = useChartTitle();
  const { t } = useTranslation();

  return (
    <div className='flex-column gap-2'>
      <Typography component='div' variant='body bold'>
        {getChartTitle(chartId, extraChartData)}
      </Typography>
      <GenericRadioConfig
        label={t('View data as:')}
        options={['SprayChart', 'SprayZone'] satisfies SprayOrSprayZoneChartView[]}
        selected={extraChartData.viewChartAs}
        setSelected={(selected) =>
          setTempLayout({
            ...tempLayout,
            [chartKey]: { ...tempLayout[chartKey], viewChartAs: selected },
          })
        }
        disabled={false}
      />
    </div>
  );
};

const BatterSprayOrSprayZoneChartSidebar = (props: ChartConfigProps<SprayOrSprayZoneChartConfigDto, BatterReportChartConfigDto>) => {
  return <PlayerSprayOrSprayZoneChartSidebar chartId='BatterSprayChart' chartKey='batterSprayChartConfig' {...props} />;
};

const BatterSessionSprayOrSprayZoneChartSidebar = (
  props: ChartConfigProps<SprayOrSprayZoneChartConfigDto, BatterSessionReportChartConfigDto>
) => {
  return <PlayerSprayOrSprayZoneChartSidebar chartId='BatterSessionSprayChart' chartKey='batterSessionSprayChartConfig' {...props} />;
};

export { BatterSprayOrSprayZoneChartSidebar, BatterSessionSprayOrSprayZoneChartSidebar };
